/* @flow */
import apiRequest from 'lib/apiRequest';
import TranscriptRequest from 'entities/TranscriptRequest';

const TranscriptRequestActions = {
  confirm(token: string): Promise<TranscriptRequest> {
    return apiRequest('/transcript_requests', 'POST', { token })
      .then(transcriptRequest => TranscriptRequest.fromJSON(transcriptRequest));
  },
};

export default TranscriptRequestActions;



// WEBPACK FOOTER //
// ./src/actions/TranscriptRequestActions.js